import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { withRouter } from "react-router-dom";

class RechargeContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    handleOpen = () => {
        this.setState({ showModal: true });
    };

    handleClose = () => {
        this.setState({ showModal: false });
    };

    render() {
        return (
            <div>
                <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                    <div
                        style={{
                            borderLeft: "3px solid #C11D6C",
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                            padding: "16px 20px",
                            marginTop: "18px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                            maxWidth: "500px",
                            width: "100%",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                            <div
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                    backgroundColor: "#C11D6C",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                    marginTop: "1px",
                                }}
                            >
                                i
                            </div>

                            <div>
                                <p style={{ margin: "0 0 4px 0", fontWeight: "700", fontSize: "14px", color: "#111" }}>
                                Changes to our recharge pricing
                                </p>

                                <p style={{ margin: "0 0 8px 0", fontSize: "14px", color: "#333" }}>
                                From 5 May 2026, our prepaid recharge prices are increasing.
                                </p>

                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.handleOpen();
                                    }}
                                    style={{
                                        color: "#C11D6C",
                                        fontWeight: "700",
                                        fontSize: "14px",
                                        textDecoration: "none",
                                    }}
                                >
                                    More on our recharge changes &#8594;
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                <Modal
                    centered
                    show={this.state.showModal}
                    onHide={this.handleClose}
                    size="md"
                >
                    <Modal.Body
                        style={{
                            padding: "30px",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                        }}
                    >

                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <span
                                onClick={this.handleClose}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "#C11D6C",
                                    fontWeight: "bold",
                                }}
                            >
                                ×
                            </span>
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <div
                                style={{
                                    width: "30px",
                                    height: "32px",
                                    borderRadius: "10px",
                                    border: "2px solid #C11D6C",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29"
                                    height="29"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#C11D6C"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <rect x="7" y="2" width="10" height="20" rx="2" ry="2" />
                                    <line x1="11" y1="18" x2="13" y2="18" />
                                </svg>
                            </div>
                        </div>


                        <h4 style={{ fontWeight: "700", marginBottom: "10px", color: "#111" }}>
                        Changes to our recharge pricing
                        </h4>


                        <p style={{ fontSize: "14px", color: "#444", marginBottom: "10px" }}>
                            From 5 May 2026, our recharge prices are increasing. For more info visit,<span style={{ color: "#C11D6C", fontWeight: "600",  textDecoration: "none",
                            }}>  telsim.com.au/planchanges  </span>
                        </p>

        

                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                onClick={this.handleClose}
                                style={{
                                    backgroundColor: "#C11D6C",
                                    color: "#fff",
                                    border: "none",
                                    padding: "10px 30px",
                                    borderRadius: "25px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export default withRouter(RechargeContent);